export default __webpack_public_path__ + "static/stadgar-brf-langgatans-smedja-82a51bd7e009cb4f2aec6df7e3a3e266.pdf";